/* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */
/* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ THIS HOLDS THE WHOLE SITE LAYOUT @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */
/* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */

import * as React from "react";
import { useLocation } from "@reach/router";
// import { useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from "./footer";
import NavBarMainHome from "./navBarMainHome";
import NavBarMobile from "./navBarMobile";
import "../styles/styles.css";
import "../styles/layout.css";
import '../fonts/hco_fonts/hco_fonts.css'
import "@fortawesome/fontawesome-free/css/all.min.css";


export default function Layout({ children, courseGroup }) {

  const data = useStaticQuery(graphql`
    query {
      allContentfulSuNavGroup {
        nodes {
          navGroupName
          navOrder
          navSlug
          styleId
          navLinkedPage {
            pageTitle
            pageSlug
          }

          navNextLevel {
            navItemName
            displayItemName
            navSlug
            excludeFromNavigation
            styleId
            navLinkedPage {
              pageTitle
              pageSlug
            }

            navNextLevel {
              navItemName
              displayItemName
              navSlug
              excludeFromNavigation
              styleId
              navLinkedPage {
                pageTitle
                pageSlug
              }

              navNextLevel {
                navItemName
                displayItemName
                navSlug
                excludeFromNavigation
                styleId
                navLinkedPage {
                  pageTitle
                  pageSlug
                }

                navNextLevel {
                  navItemName
                  displayItemName
                  navSlug
                  excludeFromNavigation
                  styleId
                  navLinkedPage {
                    pageTitle
                    pageSlug
                  }
                }
              }
            }
          }
        }
      }
      
      allContentfulSuCourse {
        nodes {
          courseTitle
          courseImage {
            url
          }
          courseDescription {
            raw
          }
          courseType
          courseSlug
          contentful_id
          id
          startOfSession
          remoteOrCampus
          classDays
          classStartTime
          academicInterest
          duration
          currentGrade
          courseCode
          crossListedCourseCode
          coreCourse
        }
      }


      allContentfulSuPage {
        nodes {
          id
          contentful_id
          pageTitle
          pageSlug
        }
      }
    }
  `);

  const menuItems = data.allContentfulSuNavGroup.nodes;

  const location = useLocation();
  let additionalClassName = '';

  if (location.pathname === "/") {
    return (
      <>
        <main fluid className="home container-fluid">{children}</main>
        <Footer />
      </>
    ); 
  } else if (location.pathname.startsWith('/courses/')) {
    return (
      <>
      <NavBarMobile menuItems={menuItems} courseGroup={courseGroup}/>
        <NavBarMainHome menuItems={menuItems} interior={true} courseGroup={courseGroup} />
        <main className="container-fluid">{children}</main>
        <Footer />
      </>
    );
  } else if (location.pathname !== "/") {
    return (
      <>
        <NavBarMobile menuItems={menuItems} />
        <NavBarMainHome menuItems={menuItems} interior={true} courseGroup={courseGroup} />
        <main className="container-fluid">{children}</main>
        <Footer />
      </>
    );
  }
}